import Container from './StudioTableMobile.container';
import StudioTableMobile from './StudioTableMobile';
export default Container(StudioTableMobile);
